/* eslint-disable react/forbid-prop-types */
import React from "react";
import PropTypes from "prop-types";
import editRegulationsRequestsStatusDictionary from "dictionary/cards/editRegulationsRequestsStatusDictionary";

function EmployeeRequestsCard(props) {
  const { request, handleOnClick } = props;
  return (
    <button
      type="button"
      style={{ textAlign: "unset" }}
      className="employee-requests__card"
      onClick={handleOnClick.bind(this, request)}
    >
      <div className="employee-requests__card__header">
        <span
          className={`badge badge--${
            editRegulationsRequestsStatusDictionary[request.STATUS].badgeColor
          }`}
        >
          {request.STATUSName}
        </span>
        {/* <div className="actions">
          <button
            type="button"
            className="employee-requests__card__action badge badge--blue"
          >
            <i className="fa-solid fa-pen" />
          </button>
          <button
            type="button"
            className="employee-requests__card__action badge badge--red"
          >
            <i className="fa-solid fa-trash-can" />
          </button>
        </div> */}
      </div>
      <div className="employee-requests__card__details mt-2">
        <p className="p">
          <span className="bold">نوع الطلب : </span>
          {request.TYPEName}
        </p>
        <p className="p">
          <span className="bold">منشئ الطلب : </span>
          {request.USERNAME}
        </p>
        <p className="p ">
          <span className="bold">التاريخ : </span>
          {request.last_edited_date_ISO}
        </p>
        <p className="p">
          <span className="bold">وصف الطلب : </span>
          {request.DESCRIPTION}
        </p>
      </div>
    </button>
  );
}

EmployeeRequestsCard.defaultProps = {
  handleOnClick: () => {},
};

EmployeeRequestsCard.propTypes = {
  request: PropTypes.object.isRequired,
  handleOnClick: PropTypes.func,
};

export default EmployeeRequestsCard;
